import { render, staticRenderFns } from "./ProjectsPublic.vue?vue&type=template&id=1257f993"
import script from "./ProjectsPublic.vue?vue&type=script&lang=js"
export * from "./ProjectsPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports